import { useRef } from "react";

/**
 * Latches the realtime-stale verdict so pausing Live polling (user idle) can't dismiss an
 * already-open dialog. The signal is only re-evaluated while polling is active; when paused
 * (`isLivePaused`) the last live verdict is held, so going idle neither opens nor closes the
 * dialog. History always clears it.
 */
export const useStickyRealtimeStale = (isHistory: boolean, isLivePaused: boolean, liveStale: boolean): boolean => {
  const ref = useRef(false);
  if (isHistory) ref.current = false;
  else if (!isLivePaused) ref.current = liveStale;
  return ref.current;
};
